import React, { useState, useEffect } from "react";
import rechercheDataService from "../services/recherche.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from './withRouter';
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import Carousel from 'react-bootstrap/Carousel';
import { useAuth0 } from '@auth0/auth0-react';
import { useToast } from './common/Toast';
import logger from '../utils/logger';

const ResultsFromStructure = () => {
  const router = useRouter();
  const { showError } = useToast();
  const { getAccessTokenSilently, loginWithRedirect, isAuthenticated } = useAuth0();
  
  const [state, setState] = useState({
    structure: [],
    planning: [],
    plage: [],
    weekDay: {"1":"Dimanche","2":"Lundi","3":"Mardi","4":"Mercredi","5":"Jeudi","6":"Vendredi","7":"Samedi"},
    weekDay2: {"1":"Dim","2":"Lun","3":"Mar","4":"Mer","5":"Jeu","6":"Ven","7":"Sam"},
    months: {"01":"Janvier","02":"Février","03":"Mars","04":"Avril","05":"Mai","06":"Juin","07":"Juillet","08":"Août","09":"Septembre","10":"Octobre","11":"Novembre","12":"Décembre"} 
  });

  const getStructure = async (id) => {
    try {
      const response = await rechercheDataService.showStructure(id);
      setState(prev => ({
        ...prev,
        structure: response.data[0]
      }));
      logger.log('Données structure récupérées:', response.data[0]);
    } catch (e) {
      logger.error('Erreur récupération structure:', e);
      showError('Erreur lors de la récupération des données de la structure');
    }
  };

  const getPlanning = async (str, spec) => {
    try {
      const response = await rechercheDataService.showPlanningFromStrSpec(str, spec);
      setState(prev => ({
        ...prev,
        planning: response.data
      }));
      logger.log('Planning récupéré:', response.data);
      
      const myplan = response.data;
      if (myplan) {
        myplan.forEach(async (plann) => {
          try {
            const plageResponse = await rechercheDataService.showPlageFromPlanning(plann.id);
            setState(prev => ({
              ...prev,
              plage: {
                ...prev.plage,
                [plann.id]: plageResponse.data
              }
            }));
          } catch (e) {
            logger.error('Erreur récupération plages:', e);
          }
        });
      }
    } catch (e) {
      logger.error('Erreur récupération planning:', e);
      showError('Erreur lors de la récupération du planning');
    }
  };

  const onClickChoixRdv = (date, creneau) => {
    !isAuthenticated ?
      loginWithRedirect({
        appState: { returnTo: '/confirmRdv/'+date+'&'+creneau }
      }) : window.location.replace('/confirmRdv/'+date+'&'+creneau); 
  };

  useEffect(() => {
    const initializeComponent = async () => {
      const http = require("../http-common").default;
      try {
        if (isAuthenticated) {
          const token = await getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: "openid profile email"
          });
          http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
          delete http.defaults.headers.common['Authorization'];
        }

        const path = window.location.pathname.split('/');
        const param = path[path.length - 1];
        const idstr = param.split('&')[0];
        const idspec = param.split('&')[1];
        getStructure(idstr);
        getPlanning(idstr, idspec);
      } catch (error) {
        logger.error('Erreur initialisation:', error);
        if (isAuthenticated) {
          showError('Erreur d\'authentification');
        }
      }
    };

    initializeComponent();
  }, [getAccessTokenSilently, isAuthenticated]);

  const { structure, planning, weekDay, weekDay2, months, plage } = state;

  return (
    <div className="col-md-12 mx-auto">
      <table style={{width:"100%"}}>
        <tbody>
          <tr style={{backgroundColor:"#6f42c1"}}>
            <td style={{padding:"20px"}}>
              {structure &&
              <table style={{color:"white"}}>
                <tbody>
                  <tr>
                    <td style={{padding:"10px"}}>
                      <FontAwesomeIcon icon={solid('hospital')} size="4x"/>
                    </td>
                    <td style={{padding:"10px"}}>
                      <span style={{fontSize:"1.5rem"}} className="lead"><b>{structure.libelle_structure}</b></span><br/>
                      <span className="lead">{structure.libelle_type_sub_terr+' '+structure.libelle_sub_terr} <FontAwesomeIcon icon={solid("location-dot")}/></span>
                    </td>
                  </tr>
                </tbody>
              </table>
              } 
            </td>
          </tr>
          <tr style={{backgroundColor:"#E6EAF7"}}>
            <td style={{paddingTop:"20px",paddingBottom:"20px",paddingLeft:"150px",paddingRight:"150px"}}>
              {planning &&
                planning.map((plann, index) => (
                    <div className="card" style={{margin:"15px"}} key={index}>
                    <div className="card-header">
                    <FontAwesomeIcon icon={solid('user-doctor')} size="2x"/><span> {plann.titre+' '+plann.nom+' '+plann.prenom}</span> 
                    </div>
                    <div className="card-body">
                    <div className="row">
                      <div className="col-lg-5">
                        <p className="lead">
                          <b>{plann.libelle_specialite}</b><br/> 
                          {plann.libelle_prestation}
                        </p>
                        <ul className="list-unstyled">
                        {(plann.agenda && plann.agenda!=='')? 
                          plann.agenda.split(" ").map((crens, crenIndex) => (
                          <li className="lead" key={crenIndex}><FontAwesomeIcon style={{color:"#D6DBDF"}} icon={solid("calendar")}/>
                          {crens.split("&").map((cren,index) =>( 
                              index===0 ? " "+weekDay[cren]+" : " : 
                              index===1 ? 
                              cren.split("_").map((cre,index) =>( 
                                  index===0 ? cre.split(":")[0]+"h"+cre.split(":")[1] : "-"+cre.split(":")[0]+"h"+cre.split(":")[1]  
                              )):
                              cren.split("_").map((cre,index) =>( 
                                index===0 ? ", "+cre.split(":")[0]+"h"+cre.split(":")[1] : "-"+cre.split(":")[0]+"h"+cre.split(":")[1]  
                            ))
                          ))} 
                          </li>                   
                        ))
                        :<li className="lead"><FontAwesomeIcon style={{color:"#D6DBDF"}} icon={solid("calendar")}/> Aucun planning renseigné.</li>
                      }
                        </ul>
                        <ul className="list-unstyled">
                          <li className="lead">Tarif: {plann.prix} FCFA</li>
                          {plann.list_ass===null?
                            <li className="lead">Aucune prise en charge.</li>
                            :<li className="lead">Prise en charge: {plann.list_ass}.</li>
                          }
                        </ul>
                        <ul className="list-unstyled">
                          {plann.contact===''?
                            <li className="lead"><FontAwesomeIcon style={{color:"#D6DBDF"}} icon={solid("phone")}/> Aucun contact renseigné.</li>
                            :
                            <li className="lead"><FontAwesomeIcon style={{color:"#D6DBDF"}} icon={solid("phone")}/>{" "+plann.contact}</li>
                          }
                        </ul>
                      </div>
                      <div className="col-lg-7">
                        <Carousel variant="dark" indicators={false} style={{backgroundColor:"#FDF2E9"}}>
                          {(plage[plann.id] && plage[plann.id]!=='') ?
                            plage[plann.id].map((plg, index) => (
                              <Carousel.Item style={{padding:"0px"}} key={index}>
                                <table style={{width:"100%"}}>
                                  <tbody>
                                    <tr>
                                      <td style={{width:"35%",padding:"15px"}} align="right">
                                        <h2><span className="badge bg-secondary">{weekDay2[plg.jr_rdv]+' '+plg.d_rdv.split("-")[2]}</span></h2>
                                        <h3>{months[plg.d_rdv.split("-")[1]]}</h3>
                                        <h6>{plg.d_rdv.split("-")[0]}</h6>
                                      </td>
                                      <td style={{width:"65%",padding:"0px"}}>
                                        {plg.all_info.split(" ").map((pl,plIndex) =>( 
                                          <button 
                                            key={plIndex}
                                            style={{marginBottom:"10px"}} 
                                            type="button" 
                                            className="btn btn-info btn-sm"
                                            onClick={e => onClickChoixRdv(plg.d_rdv,pl.split('&')[5])}
                                          >
                                            <FontAwesomeIcon icon={regular('bell')}/>{'  '+pl.split('&')[0].split(':')[0]+'h'+pl.split('&')[0].split(':')[1]+' - '+pl.split('&')[1].split(':')[0]+'h'+pl.split('&')[1].split(':')[1]+', '} 
                                            patient n° <span className="badge bg-success">{pl.split('&')[2]+'/'+pl.split('&')[3]}</span> ( ± {pl.split('&')[4].split(':')[0]+'h'+pl.split('&')[4].split(':')[1]} )
                                          </button>
                                        ))} 
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </Carousel.Item> 
                            ))
                            :<Carousel.Item>
                              <p style={{margin:"40px", textAlign:"center"}} className="lead">La prise de rendez-vous en ligne n'est pas disponible pour cette prestation. Veuillez vous rapprocher de la structure sanitaire.</p>
                            </Carousel.Item>
                          }
                            
                        </Carousel>
                      </div>
                    </div>
                      
                    </div>
                  </div>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ResultsFromStructure;